import React from 'react';
import { useFamilyFinder } from '../context/FamilyFinderContext';
import '../styles/familyFinder.css';

const SupervisionOverviewPage = () => {
  const { supervisionAnalytics, refreshSupervisionAnalytics } = useFamilyFinder();

  if (!supervisionAnalytics) {
    return <div className="family-finder-loading">Loading supervision overview…</div>;
  }

  return (
    <div className="supervision-page">
      <header className="supervision-page__header">
        <div>
          <h1>Relational Supervision Overview</h1>
          <p>Focus priorities for the upcoming supervision cycle aligned with GPA.</p>
          <small>Last refreshed {new Date(supervisionAnalytics.lastRefreshedAt).toLocaleString()}</small>
        </div>
        <button type="button" className="primary" onClick={refreshSupervisionAnalytics}>
          Refresh
        </button>
      </header>
      <section className="supervision-page__summary">
        <div>
          <span>Total Children</span>
          <strong>{supervisionAnalytics.totalChildren}</strong>
        </div>
        <div>
          <span>Average Network Health</span>
          <strong>{supervisionAnalytics.averageNetworkHealth}</strong>
        </div>
      </section>
      <table className="supervision-page__table">
        <thead>
          <tr>
            <th>Child</th>
            <th>Network Health</th>
            <th>Active Members</th>
            <th>Overdue Contacts (&gt;30d)</th>
            <th>Flags</th>
          </tr>
        </thead>
        <tbody>
          {supervisionAnalytics.children.map((child) => (
            <tr key={child.childId}>
              <td>
                <strong>{child.childName}</strong>
                <div className="supervision-page__actions">
                  <a href={`/child/${child.childId}/family-finder`} className="link">
                    Open Family Finder
                  </a>
                </div>
              </td>
              <td>{child.networkHealthScore}</td>
              <td>{child.activeMembers}</td>
              <td>{child.overdueContacts}</td>
              <td>
                {child.flags.length === 0 ? (
                  <span className="badge badge--success">All recent</span>
                ) : (
                  <ul>
                    {child.flags.map((flag) => (
                      <li key={flag.memberId}>
                        {flag.name} — {flag.daysSinceContact} days
                      </li>
                    ))}
                  </ul>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SupervisionOverviewPage;
